// Agency related endpoints
export const agencyEndpoints = (builder) => ({
  // Agency CRUD operations
  // services/redux/api/endpoints.js (agencyEndpoints)
  getAgencies: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/get-Agency',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Agency'],
  }),

  getAgencyById: builder.query({
    query: (id) => ({
      url: `/common/get-AgencyById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Agency', id }],
  }),

  saveAgency: builder.mutation({
    query: (data) => ({
      url: '/common/save-Agency',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Agency'],
  }),

  updateAgency: builder.mutation({
    query: ({ data }) => ({
      url: `/common/save-Agency`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'Agency', id },
      'Agency'
    ],
  }),

  deleteAgency: builder.mutation({
    query: (id) => ({
      url: `/common/delete-Agency/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Agency'],
  }),

  bulkDeleteAgency: builder.mutation({
    query: (body) => ({
      url: "/common/bulk-delete-agency",
      method: "DELETE",
      body,
    }),
  }),

});
